export default {
  path: '/plantProtect',
  name: 'plantProtect',
  component: () => import('@/layouts/BaseLayout'),
  redirect: '/plantProtect/pesticide',
  children: [
    {
      path: 'pesticide',
      meta: { title: '农药手册' },
      component: () => import('@/views/plantProtect/pesticide/index'),
    },
    {
      path: 'weed',
      meta: { title: '杂草手册' },
      component: () => import('@/views/plantProtect/weed/index'),
    },
    {
      path: 'pest',
      meta: { title: '虫害手册' },
      component: () => import('@/views/plantProtect/pest/index'),
    },
    {
      path: 'disease',
      meta: { title: '病害手册' },
      component: () => import('@/views/plantProtect/disease/index'),
    },
  ],
}
